import React from "react";
import { asText, memberByName, sortTeam, teamChip } from "../briefModel";
import "../../_shared/QokrPrimitives/_qokr-pill.scss";
import "../BriefCoverageTable/_brief-table.scss";

// The team (handoff 34 §4 ⑤): member · objectives · KRs · initiatives ·
// status · note, problems first. `member` is a name; one that matches a
// review member links to that person on the Review's Individual OKRs tab.
const count = (value) =>
  Number.isFinite(Number(value)) && value !== null && value !== ""
    ? Number(value)
    : "–";

const BriefTeamTable = ({ rows, review, onOpenMember }) => {
  const list = sortTeam(rows).filter((row) => asText(row.member));
  if (!list.length) {
    return <div className="scb-empty-state">The brief has no team rows.</div>;
  }
  const findMember = memberByName(review);

  return (
    <div className="qokr-brief-table qokr-brief-table--team" role="table">
      <div className="qokr-brief-table__head" role="row">
        <span role="columnheader">Member</span>
        <span role="columnheader">Objectives</span>
        <span role="columnheader">KRs</span>
        <span role="columnheader">Initiatives</span>
        <span role="columnheader">Status</span>
        <span role="columnheader">Note</span>
      </div>
      {list.map((row, index) => {
        const chip = teamChip(row.status);
        const member = findMember(row.member);
        return (
          <div className="qokr-brief-table__row" role="row" key={index}>
            <span
              className="qokr-brief-table__cell qokr-brief-table__cell--title"
              role="cell"
            >
              {member && onOpenMember ? (
                <button
                  type="button"
                  className="qokr-brief-table__link"
                  onClick={() => onOpenMember(member)}
                >
                  {asText(row.member)}
                </button>
              ) : (
                asText(row.member)
              )}
            </span>
            <span
              className="qokr-brief-table__cell qokr-brief-table__cell--num"
              role="cell"
              data-label="Objectives"
            >
              {count(row.objectives)}
            </span>
            <span
              className="qokr-brief-table__cell qokr-brief-table__cell--num"
              role="cell"
              data-label="KRs"
            >
              {count(row.key_results)}
            </span>
            <span
              className="qokr-brief-table__cell qokr-brief-table__cell--num"
              role="cell"
              data-label="Initiatives"
            >
              {count(row.initiatives)}
            </span>
            <span className="qokr-brief-table__cell" role="cell">
              <span className={`qokr-pill qokr-pill--${chip.tone}`}>
                {chip.label}
              </span>
            </span>
            <span
              className="qokr-brief-table__cell qokr-brief-table__cell--note"
              role="cell"
              data-label="Note"
            >
              {asText(row.note)}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default BriefTeamTable;
